import parameterActionTypes from './parameterActionTypes';

const initialState = {
  pending: false,
  parameterSet: [],
  parameters: [],
  parametersOptions: [],
  error: null,
  createdValue: '',
  deletedId: ''
};

const parameterReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case parameterActionTypes.GET_PARAMETERS_START:
    case parameterActionTypes.DELETE_PARAMETER_VALUE_START:
    case parameterActionTypes.DELETE_PARAMETER_SET_START:
    case parameterActionTypes.GET_PARAMETER_OPTIONS_START:
      return {
        ...state,
        pending: true
      };
    case parameterActionTypes.GET_PARAMETERS_SUCCESS:
      return {
        ...state,
        pending: false,
        parameters: payload
      };

    case parameterActionTypes.GET_PARAMETERS_FAILED:
      return {
        ...state,
        pending: false,
        error: payload
      };

    case parameterActionTypes.GET_PARAMETERS_SET_START:
      return {
        ...state,
        pending: true
      };

    case parameterActionTypes.GET_PARAMETERS_SET_SUCCESS:
      return {
        ...state,
        pending: false,
        parameterSet: payload
      };

    case parameterActionTypes.GET_PARAMETERS_SET_FAILED:
      return {
        ...state,
        pending: false,
        error: payload
      };

    case parameterActionTypes.SAVE_PARAMETER_START:
      return {
        ...state,
        pending: true
      };

    case parameterActionTypes.SAVE_PARAMETER_VALUE_SUCCESS:
      return {
        ...state,
        pending: false,
        createdValue: payload
      };

    case parameterActionTypes.DELETE_PARAMETER_VALUE_SUCCESS:
      return {
        ...state,
        pending: false,
        deletedId: payload
      };

    case parameterActionTypes.DELETE_PARAMETER_SET_SUCCESS:
      return {
        ...state,
        pending: false,
        deletedId: payload
      };

    case parameterActionTypes.GET_PARAMETER_OPTIONS_SUCCESS:
      return {
        ...state,
        pending: false,
        parametersOptions: payload
      };

    case parameterActionTypes.UPDATE_PARAMETER_OPTIONS_STATE:
      return {
        ...state,
        parametersOptions: state.parametersOptions.map((row, i) =>
          i === payload.index ? { ...row, [payload.prop]: payload.value } : row
        )
      };

    case parameterActionTypes.REMOVE_PARAMETER_OPTION_FROM_STATE:
      return {
        ...state,
        parametersOptions: state.parametersOptions.filter(
          row => row.id !== payload
        )
      };

    case parameterActionTypes.SAVE_PARAMETER_VALUE_FAILED:
    case parameterActionTypes.SAVE_PARAMETER_SET_FAILED:
    case parameterActionTypes.DELETE_PARAMETER_VALUE_FAILED:
    case parameterActionTypes.DELETE_PARAMETER_SET_FAILED:
    case parameterActionTypes.GET_PARAMETER_OPTIONS_FAILED:
      return {
        ...state,
        pending: false,
        error: payload
      };

    default:
      return state;
  }
};

export default parameterReducer;
